import { useLocation, useNavigate, useParams, type Location, type NavigateFunction, type Params } from 'react-router';

/*
    this is a wrapper component, because react router 6 should be used with hooks
    unless we do not want to rewrite all components,
    we can just wrap the withRouter function from react router v5
    https://gist.github.com/sibelius/7d760fa16a121ec0f4cd8b143a59bee6
*/

// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience for migration to biomejs
export const withRouter = (Component: any) => {
    // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience for migration to biomejs
    const Wrapper = (props: any) => {
        const location = useLocation();
        const params = useParams();
        const push = useNavigate();

        return <Component location={location} params={params} push={push} {...props} />;
    };

    return Wrapper;
};

export interface RouteComponentProps {
    location: Location;
    params: Readonly<Params>;
    push: NavigateFunction;
}

export function historyPushLocation(
    navigateFunction: NavigateFunction,
    location: { pathname: string; search: string }
) {
    const s = `/${location.pathname.replace(/^\//, '')}${location.search}`;
    navigateFunction(s, { replace: false });
}
